import React, { useState ,useEffect} from 'react';
import { v4 as uuidv4 } from 'uuid';
import './chat.css'; // Add a CSS file for styling

function Chat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [file, setFile] = useState(null); // State for file upload
  const [sessionId, setSessionId] = useState(''); // State for session ID
  const [fileList, setFileList] = useState([]); // State for list of files
  const [chatList, setChatList] = useState([]); // State for list of chats
  const userData = JSON.parse(localStorage.getItem('userdata')); // Retrieve user data from local storage

    // Generate a random session ID when the component mounts
    useEffect(() => {
      const generatedSessionId = uuidv4(); // Generate a unique session ID
      setSessionId(generatedSessionId);
    }, []);

  const handleSendMessage = async () => {
    if (input.trim() !== '') {
      const userMessage = { text: input, sender: userData.username, timestamp: new Date().toISOString() };
      setMessages([...messages, userMessage]);
      setInput('');

      try {
const userData = JSON.parse(localStorage.getItem('userdata')); 

        const response = await fetch('http://127.0.0.1:8000/chat', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ query: input, userData }),
        });

        if (response.ok) {
          const data = await response.json();
          const systemMessage = { text: data.response, sender: 'system', timestamp: data.timestamp };
          setMessages((prevMessages) => [...prevMessages, systemMessage]);
        } else {
          console.error('Error from backend:', response.statusText);
          const errorMessage = { text: 'Error: Unable to fetch response from server.', sender: 'system', timestamp: new Date().toISOString() };
          setMessages((prevMessages) => [...prevMessages, errorMessage]);
        }
      } catch (error) {
        console.error('Error:', error);
        const errorMessage = { text: 'Error: Unable to connect to server.', sender: 'system', timestamp: new Date().toISOString() };
        setMessages((prevMessages) => [...prevMessages, errorMessage]);
      }
       // Call saveChatToHistory after sending the message
    saveChatToHistory();
    }
  };



// Add the new function to handle saving the old chat and starting a new session
const handleNewChatSession = async () => {
  if (!sessionId) {
    alert('No active session to save.');
    return;
  }

  try {
    const userData = JSON.parse(localStorage.getItem('userdata'));
    const response = await fetch('http://127.0.0.1:8000/save-chat/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ session_id: sessionId, chat: messages, userData }),
    });

    if (response.ok) {
      const data = await response.json();
      alert(data.message);

      // Generate a new session ID
      const newSessionId = uuidv4();
      setSessionId(newSessionId);

      // Clear the current chat messages
      setMessages([]);
    } else {
      alert('Failed to save chat.');
    }
  } catch (error) {
    console.error('Error saving chat:', error);
    alert('An error occurred while saving the chat.');
  }
};

  
  const saveChatToHistory = async () => {
    if (!sessionId) {
      alert('Please enter a session ID to save the chat.');
      return;
    }

    try {
      const userData = JSON.parse(localStorage.getItem('userdata'));
      const response = await fetch('http://127.0.0.1:8000/save-chat/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ session_id: sessionId, chat: messages ,userData}),
      });

      if (response.ok) {
        const data = await response.json();
        // alert(data.message);
        fetchChatList(); // Automatically refresh the chat list after saving
      } else {
        alert('Failed to save chat.');
      }
    } catch (error) {
      console.error('Error saving chat:', error);
      alert('An error occurred while saving the chat.');
    }
  };

  const fetchChatList = async () => {
    if (!sessionId) {
      alert('Please enter a session ID to fetch chats.');
      return;
    }

    const username = JSON.parse(localStorage.getItem('userdata')).username;

    try {
      
      const response = await fetch(`http://127.0.0.1:8000/list-chats/?username=${username}&session_id=${sessionId}`);
      if (response.ok) {
        const data = await response.json();
        setChatList(data.chats);
      } else {
        alert('Failed to fetch chat list.');
      }
    } catch (error) {
      console.error('Error fetching chat list:', error);
      alert('An error occurred while fetching the chat list.');
    }
  };

  const fetchChatContent = async (fileName) => {
    if (!sessionId) {
      alert('Please enter a session ID to fetch chat content.');
      return;
    }

    try {
      const response = await fetch(`http://127.0.0.1:8000/get-chat/?session_id=${sessionId}&file_name=${fileName}&username=${userData.username}`);
      if (response.ok) {
        const data = await response.json();
        setMessages(data.chat); // Render the chat content in the UI
      } else {
        alert('Failed to fetch chat content.');
      }
    } catch (error) {
      console.error('Error fetching chat content:', error);
      alert('An error occurred while fetching the chat content.');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
      
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!file || !sessionId) {
      alert('Please select a file and enter a session ID.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('session_id', sessionId);

    try {
      formData.append('userData', JSON.stringify(userData)); // Include local storage data in the request

      const response = await fetch('http://127.0.0.1:8000/upload-file/', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        alert(data.message);
        fetchFileList(); // Automatically refresh the file list after upload
      } else {
        alert('Failed to upload file.');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('An error occurred while uploading the file.');
    }
  };
  const fetchFileList = async () => {
    if (!sessionId) {
      alert('Please enter a session ID to fetch files.');
      return;
    }

    try {
      const response = await fetch(`http://127.0.0.1:8000/list-files/?session_id=${sessionId}&username=${JSON.parse(localStorage.getItem('userdata')).username}`);
      if (response.ok) {
        const data = await response.json();
        setFileList(data.files);
      } else {
        alert('Failed to fetch file list.');
      }
    } catch (error) {
      console.error('Error fetching file list:', error);
      alert('An error occurred while fetching the file list.');
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-sidebar">
        <h3>Chat History</h3>
        <button onClick={fetchChatList} className="fetch-chats-button">
          Refresh Chat List
        </button>
        <ul>
          {chatList.map((chat, index) => (
            <li key={index}>
              <button onClick={() => fetchChatContent(chat)}>
                {chat}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="chat-main">
        <div className="chat-header">
          <h2>hello {userData.username}</h2>
          <button onClick={handleNewChatSession} className="save-history-button">
New Chat
</button>
        </div>
        <div className="chat-messages">
          {messages.map((message, index) => (
        <div
          key={index}
          className={`chat-message ${message.sender === userData.username ? 'user-message' : 'system-message'}`}
        >
          <div className="message-sender">
            <strong>{message.sender}</strong>
            
          </div>
       
          <div className="message-text" dangerouslySetInnerHTML={{ __html: message.text }}></div>
   
        </div>
      ))}
    </div>
        <div className="chat-input-container">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type your message..."
            className="chat-input"
          />
          <button onClick={handleSendMessage} className="chat-send-button">
            Send
          </button>
        </div>
      </div>
      <div className="file-upload-sidebar">
        <h3>Upload File</h3>
        <input
          type="text"
          placeholder="Enter Session ID"
          value={sessionId}
          // onChange={(e) => setSessionId(e.target.value)}
          className="session-id-input"
        />
        <input type="file" onChange={handleFileChange} className="file-input" />
        <button onClick={handleFileUpload} className="file-upload-button">
          Upload
        </button>
        <h3>Files in Session</h3>
        <button onClick={fetchFileList} className="fetch-files-button">
          Refresh File List
        </button>
        <ul>
          {fileList.map((file, index) => (
            <li key={index}>{file}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Chat;